import flatMap from 'lodash/flatMap'
import groupBy from 'lodash/groupBy'

import { CustomizationField } from 'modules/expenses/hooks/useExpensesCustomization'

/**
 * There is a copy of this file in
 * @mobile/src/screens/Expenses/ExpensableForm/lib/customization_settings/filterByExpenseDocumentType.ts
 *
 * Ideally this operation should be done in the backend to avoid logic duplication
 * But there are enough challenges to delay this implementation for now:
 *
 * - The FE would have to deal with a dealy when changing the document type
 * - For BE we would have to implement a new filter parameter expense_document_type
 *   that could be 'invoice', 'receipt', 'other' or 'nil'. But also we need a way
 *   to ask for not filtering by expense_document_type, so Maybe[T.nilable[String]]
 *   could be a solution, but this is not being correctly translated to graphql atm
 *
 * @param customizationFields
 * @param documentType
 * @returns
 */
export const filterCustomizationFieldsByExpenseDocumentType = (
  customizationFields: CustomizationField[],
  documentType?: string
) => {
  // First, group by 'resource_type' and 'identifier'
  const grouped = groupBy(customizationFields, (curr) => `${curr.resourceType}-${curr.identifier}`)

  // Then, for each group, select the appropriate element
  const filtered = flatMap(grouped, (group) => {
    if (group[0]?.resourceType === 'expense') {
      if (documentType === 'invoice') {
        // Try to find an 'invoice' element, fall back to 'default'
        return (
          group.find((el) => el.documentType === 'invoice') ||
          group.find((el) => el.documentType === 'default')
        )
      } else {
        // Always return 'default'
        return group.find((el) => el.documentType === 'default')
      }
    } else {
      return group
    }
  }).filter((el): el is CustomizationField => el !== undefined)

  return filtered
}
